/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { HttpService } from '@angular-kit/core';

import { PublicHoliday, PublicHolidayData } from '@teamworks/global';

@Injectable()
export class PublicHolidayService {

  constructor(private httpService: HttpService) { }

  async loadPublicHolidayList(year: string, month: string): Promise<PublicHoliday[]> {
    return this.httpService.get(`api/time-recording/public-holiday/${year}/${month}`)
      .then((loadedData: PublicHolidayData[]) => loadedData.map(data => new PublicHoliday(data)));
  }

}
